// extracted by mini-css-extract-plugin
export default {"modal":"qrcoderangemodal_modal__f8Zmr","input":"qrcoderangemodal_input__2b1Ob"};